module.exports = function() {
  return new Worker("/" + "babel-transpiler.f80f7252.worker.js");
};